import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { AppState, AuthTokenInfo, FeaturesTree, GetterClass } from '../../../models';

import { FeaturesTreeUtils } from '../../../utils';

import { AUTH_CONSTS } from '../../auth/auth.consts';
import { CONFIG_CONSTS } from '../../config/config.consts';

export class FeaturesTreeGetter implements GetterClass {

  public static execute(state: AppState, getters: any, rootState: any, rootGetters: any): FeaturesTree {
    const instanceConfig: Instance = rootGetters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`];
    const authTokenInfo: AuthTokenInfo = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.tokenInfo }`];
    return FeaturesTreeUtils.getFeaturesTree(instanceConfig, authTokenInfo.authorization);
  }

}
